module.exports = __webpack_public_path__ + "static/media/movie.859f03a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/movie.gif
// module id = 1644
// module chunks = 0